module.exports = __webpack_public_path__ + "img/ic_24_playlist_edit.98f56805.svg";